import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcDocument = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 52 52"
    {...props}
  >
    <rect width={52} height={52} y={0.952} fill="#EEF4FF" rx={4} />
    <path
      fill="#5590FF"
      d="M31.3 43.948c1.704 0 3.092-.922 3.12-2.626v-1.34a.67.67 0 0 1 .65-.64h3.5a1 1 0 0 0 1-1s0 2.3-2.67 4.31c-1.601 1.166-3.53 1.351-5.51 1.356l-.09-.06Z"
      opacity={0.6}
    />
    <path
      fill="#D4E4FF"
      stroke="#5590FF"
      strokeLinejoin="round"
      d="M13.581 9.951a1.08 1.08 0 0 0-1.09 1.08v31.837a1.08 1.08 0 0 0 1.09 1.08h17.72a3.12 3.12 0 0 0 3.12-3.07v-1.33a.65.65 0 0 1 .65-.64h3.5a1 1 0 0 0 1-1V11.03a1.08 1.08 0 0 0-1.09-1.08h-24.9Z"
    />
    <path
      stroke="#5590FF"
      strokeLinecap="round"
      d="M16.42 14.952h6-6Z"
      clipRule="evenodd"
    />
    <path
      stroke="#5590FF"
      strokeLinecap="round"
      d="M39.57 37.99s.05 2.624-2.62 4.707c-1.601 1.208-3.55 1.246-5.53 1.25"
    />
    <path
      stroke="#5590FF"
      strokeLinecap="round"
      d="M16.42 20.952h19.075H16.42ZM16.42 24.952h19.075H16.42ZM16.42 28.952h9-9Z"
      clipRule="evenodd"
    />
    <path
      stroke="#5590FF"
      d="M16.42 38.952h9-9ZM16.42 40.952h5-5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIcDocument;
